@if (client$ | async; as client) {
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>Access Tokens</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
                @for (accessToken of accessTokens$ | async; track accessToken) {
                    <mat-list-item>
                        <span matListItemTitle>{{ accessToken.title }}</span>
                        <span matListItemLine>{{ accessToken.description }}</span>
                        <span matListItemLine>{{ accessToken.expires | date: "short" }}</span>
                        <button
                            mat-icon-button
                            matListItemMeta
                            (click)="removeAccessToken(accessToken.id)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-list-item>
                }
            </div>
        </mat-card-content>
        <mat-card-actions>
            <button mat-stroked-button color="primary" (click)="openDialog()">
                <mat-icon>add</mat-icon>
                Create Token
            </button>
        </mat-card-actions>
    </mat-card>
}
